<template>
  <div>
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview
          v-bind:title="'Kiểm tra sản phẩm tính hoa hồng cửa hàng'"
          style="width: 100%"
        >
          <template v-slot:preview>
            <!-- Header Filter -->
            <div class="col-md-12 mb-5">
              <b-form>
                <b-row class="mb-3">
                  <b-col md="3">
                    <label class="mb-0">Tháng năm</label>
                    <date-picker
                      v-model="selectedMonth"
                      placeholder="Chọn tháng năm"
                      class="form-control form-control-sm"
                      :config="dpConfigs.monthReport"
                    ></date-picker>
                  </b-col>
                  <b-col md="3">
                    <label class="mb-0">Loại hoa hồng</label>
                    <b-form-select
                      v-model="selectedRewardType"
                      :options="rewardTypeOptions"
                      placeholder="Chọn loại hoa hồng"
                      class="select-style"
                      size="sm"
                    ></b-form-select>
                  </b-col>
                  <b-col
                    md="3"
                    v-if="
                      selectedRewardType &&
                      selectedRewardType === REWARD_CHECK_TYPE.CH
                    "
                  >
                    <label class="mb-0">Cửa hàng:</label>
                    <Autosuggest
                      :key="'store-' + componentKey"
                      :model="selectedStoreName"
                      :suggestions="filteredStoreOptions"
                      placeholder="cửa hàng"
                      :limit="10"
                      @select="onSelectStores($event)"
                      @change="onInputStoreChange"
                      suggestionName="suggestionName"
                    />
                  </b-col>
                  <b-col
                    md="3"
                    v-if="selectedRewardType === REWARD_CHECK_TYPE.CR"
                  >
                    <label class="mb-0">Bộ phận:</label>
                    <Autosuggest
                      :key="'department-' + componentKey"
                      :model="selectedDepartmentName"
                      :suggestions="filteredDepartmentOptions"
                      placeholder="bộ phận"
                      :limit="10"
                      @select="onSelectDepartments($event)"
                      @change="onInputDepartmentChange"
                      suggestionName="suggestionName"
                    />
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col md="6">
                    <label class="mb-0">Sản phẩm</label>
                    <Autosuggest
                      :key="'product-' + componentKey"
                      :model="selectedProductName"
                      :suggestions="listProductFilter"
                      placeholder="sản phẩm"
                      :limit="10"
                      @select="onSelectProducts($event)"
                      @change="onProductChange"
                      suggestionName="suggestionName"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <div class="d-flex justify-content-left gap-3">
                      <b-button
                        variant="primary"
                        size="md"
                        @click="handleCheckReward"
                        :disabled="onLoading"
                        class="mr-1"
                      >
                        <i class="fas fa-search"></i>
                        <span v-if="!onLoading">Kiểm tra</span>
                        <span v-else>
                          <i class="fas fa-spinner fa-spin"></i>
                          Đang kiểm tra...
                        </span>
                      </b-button>
                      <b-button
                        variant="outline-secondary"
                        size="md"
                        @click="handleReset"
                      >
                        <i class="fas fa-undo"></i>
                        Làm mới
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </div>
            <!-- Table Data -->
            <div class="px-4">
              <b-table
                id="my-table-main"
                class="table-bordered table-hover"
                :fields="fields"
                :items="rewardPrograms"
                v-if="renderListRewardProgram"
                :busy="onLoading"
              >
                <template v-slot:cell(name)="row">
                  <span
                    v-if="checkPermission('REWARD_CHECK_VIEW')"
                    @click="handleViewDetailProgram(row.item.id)"
                    class="hover-link"
                  >
                    {{ row.item.name }}
                  </span>
                  <span v-else>
                    {{ row.item.name }}
                  </span>
                </template>
                <template v-slot:cell(proCateName)="row">
                  <div class="my-1">
                    <span
                      v-if="checkPermission('REWARD_CHECK_VIEW')"
                      @click="handleViewDetailCategory(row.item.proCateId)"
                      class="hover-link"
                    >
                      {{ row.item.proCateName }}
                    </span>
                    <span v-else>
                      {{ row.item.proCateName }}
                    </span>
                  </div>
                </template>
                <template v-slot:cell(amount1)="row">
                  {{ row.item.amount1 }}
                </template>
                <template v-slot:cell(amount1Operator)="row">
                  {{ getAmountOperatorText(row.item.amount1Operator) }}
                </template>
                <template v-slot:cell(amount2)="row">
                  {{ row.item.amount2 }}
                </template>
                <template v-slot:cell(amount2Operator)="row">
                  {{ getAmountOperatorText(row.item.amount2Operator) }}
                </template>
              </b-table>
              <div class="col-md-12" v-else-if="!onLoading">
                <div class="card">
                  <div class="card-body text-center py-5">
                    <i class="fas fa-search fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted">Chưa có kết quả tìm kiếm</h5>
                    <p class="text-muted">
                      Vui lòng nhập thông tin và nhấn "Kiểm tra" để xem kết quả
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { TIME_TRIGGER, REWARD_PROGRAM_TYPE } from '@/utils/constants';
import { removeAccents, makeToastFaile } from '@/utils/common';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { formatDate, formatSpecificDate } from '@/utils/date';
import { mapGetters } from 'vuex';
import Loader from '@/view/content/Loader.vue';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { getToastInstance } from '@/utils/toastHelper';
import { REWARD_CHECK_TYPE } from '@/utils/enum';
import { REWARD_CHECK_TYPE_NAME } from '@/utils/enum-name';
import { handleError } from '@/utils/common';
import permissionMixin from '@/view/mixins/permission.mixin';
import apiCommonMixin from '@/view/mixins/api-common.mixins';

export default {
  mixins: [permissionMixin, apiCommonMixin],
  data() {
    const currentMonth = new Date();

    return {
      REWARD_CHECK_TYPE,
      selectedRewardType: REWARD_CHECK_TYPE.CH,
      rewardTypeOptions: Object.keys(REWARD_CHECK_TYPE).map((key) => {
        return {
          value: REWARD_CHECK_TYPE[key],
          text: REWARD_CHECK_TYPE_NAME[key],
        };
      }),
      selectedProductName: null,
      selectedProductId: null,
      selectedStoreName: null,
      selectedStoreId: null,
      selectedDepartmentName: null,
      selectedDepartmentId: null,
      rewardPrograms: [],
      listProductFilter: [],
      filteredStoreOptions: [],
      departmentOptions: [],
      filteredDepartmentOptions: [],
      renderListRewardProgram: false,
      onLoading: false,
      selectedMonth: currentMonth,
      componentKey: 0,
      dpConfigs: {
        monthReport: {
          format: 'MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      fields: [
        {
          key: 'name',
          label: 'Tên chương trình',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-left',
        },
        {
          key: 'proCateName',
          label: 'Tên nhóm HH',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-left',
        },
        {
          key: 'amount1',
          label: 'Giá trị 1',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-center',
        },
        {
          key: 'amount1Operator',
          label: 'Toán tử 1',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-center',
        },
        {
          key: 'proCateTypeShortName',
          label: 'Loại',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-center',
        },
        {
          key: 'amount2Operator',
          label: 'Toán tử 2',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-center',
        },
        {
          key: 'amount2',
          label: 'Giá trị 2',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-center',
        },
      ],
    };
  },
  components: {
    KTCodePreview,
    Loader,
    Autosuggest,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'Kiểm tra sản phẩm tính hoa hồng cửa hàng',
        route: 'reward-check',
      },
      { title: 'Kiểm tra sản phẩm tính hoa hồng cửa hàng' },
    ]);
  },
  computed: {
    ...mapGetters(['breadcrumbs', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },
  },
  watch: {
    selectedRewardType(newValue) {
      if (newValue === REWARD_CHECK_TYPE.CH) {
        this.selectedDepartmentId = null;
        this.selectedDepartmentName = null;
      } else if (newValue === REWARD_CHECK_TYPE.CR) {
        this.selectedStoreId = null;
        this.selectedStoreName = null;
      }
    },
  },
  created() {
    this.fetchStore();
    this.loadDepartments();
  },
  methods: {
    getAmountOperatorText(value) {
      const operatorMap = {
        1: '--',
        2: '<',
        3: '>',
        4: '≤',
        5: '≥',
      };
      return operatorMap[value] || '';
    },
    ...getToastInstance(),
    formatDate: formatDate,
    onProductChange(name) {
      this.debounceInputProduct(name);
    },
    debounceInputProduct: debounce(function (name) {
      this.searchProduct(name);
    }, TIME_TRIGGER),
    onSelectProducts(option) {
      this.selectedProductName = option.item.productName;
      this.selectedProductId = option.item.id;
    },
    searchProduct(name) {
      const params = { name };

      ApiService.query('products/searchProductByName', { params }).then(
        (response) => {
          this.listProductFilter = [];

          response.data.data.forEach((item) => {
            let suggestionName = item.productName;
            if (item.productCode !== '') {
              suggestionName = item.productName;
            }
            const product = {
              id: item.id,
              name: item.productName,
              code: item.productCode,
              suggestionName: suggestionName,
            };
            this.listProductFilter.push(product);
          });
        },
      );
    },
    onInputStoreChange(text) {
      this.selectedStoreName = text;
      const filterData = this.storeOptions.filter((item) => {
        return (
          removeAccents(item.name)
            .toLowerCase()
            .indexOf(removeAccents(text).toLowerCase()) > -1
        );
      });

      this.filteredStoreOptions = [...filterData];

      if (this.selectedStoreName === '') {
        this.filteredStoreOptions = [...this.storeOptions];
        this.selectedStoreId = null;
      }
      if (!this.selectedStoreName) {
        this.selectedStoreId = null;
      }
    },
    onSelectStores(option) {
      this.selectedStoreName = option.item.StoreName;
      this.selectedStoreId = option.item.id;
    },
    fetchStore: async function () {
      ApiService.setHeader();
      ApiService.get('/stores/getStores').then((response) => {
        const stores = response.data.data;
        this.storeOptions = stores.map((item) => {
          return {
            id: item.id,
            suggestionName: item.name,
            name: item.name,
          };
        });

        this.filteredStoreOptions = [...this.storeOptions];
      });
    },
    loadDepartments: async function () {
      try {
        const departments = await this.fetchDepartments();
        this.departmentOptions = departments.map((item) => {
          return {
            id: item.id,
            suggestionName: item.name,
            name: item.name,
          };
        });
        this.filteredDepartmentOptions = [...this.departmentOptions];
      } catch (error) {
        handleError(error);
      }
    },
    onInputDepartmentChange(text) {
      this.selectedDepartmentName = text;
      const filterData = this.departmentOptions.filter((item) => {
        return (
          removeAccents(item.name)
            .toLowerCase()
            .indexOf(removeAccents(text).toLowerCase()) > -1
        );
      });

      this.filteredDepartmentOptions = [...filterData];

      if (this.selectedDepartmentName === '') {
        this.filteredDepartmentOptions = [...this.departmentOptions];
        this.selectedDepartmentId = null;
      }
      if (!this.selectedDepartmentName) {
        this.selectedDepartmentId = null;
      }
    },
    onSelectDepartments(option) {
      this.selectedDepartmentName = option.item.name;
      this.selectedDepartmentId = option.item.id;
    },
    handleCheckReward() {
      if (!this.selectedRewardType) {
        makeToastFaile('Vui lòng chọn loại hoa hồng!');
        return;
      }

      if (!this.selectedProductId) {
        makeToastFaile('Vui lòng chọn sản phẩm!');
        return;
      }

      if (
        this.selectedRewardType === REWARD_CHECK_TYPE.CH &&
        !this.selectedStoreId
      ) {
        makeToastFaile('Vui lòng chọn cửa hàng!');
        return;
      }

      if (
        this.selectedRewardType === REWARD_CHECK_TYPE.CR &&
        !this.selectedDepartmentId
      ) {
        makeToastFaile('Vui lòng chọn bộ phận!');
        return;
      }

      if (!this.selectedMonth) {
        makeToastFaile('Vui lòng chọn tháng!');
        return;
      }

      if (this.onLoading) {
        return;
      }
      this.onLoading = true;

      const params = {
        rewardType: this.selectedRewardType,
        productId: this.selectedProductId,
        month: formatSpecificDate(this.selectedMonth, 'MM/YYYY', 'YYYY-MM'),
      };

      if (this.selectedRewardType === REWARD_CHECK_TYPE.CH) {
        params.storeId = this.selectedStoreId;
        params.rewardType = REWARD_PROGRAM_TYPE.HH_CH;
      } else if (this.selectedRewardType === REWARD_CHECK_TYPE.CR) {
        params.departmentId = this.selectedDepartmentId;
        params.rewardType = REWARD_PROGRAM_TYPE.HH_CR;
      }

      const apiEndpoint = 'v1/reward-reports/check';

      ApiService.query(apiEndpoint, { params })
        .then(({ data: { data } }) => {
          this.rewardPrograms = data;
          this.renderListRewardProgram = true;
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.onLoading = false;
        });
    },
    handleViewDetailCategory(id) {
      const url = this.$router.resolve({
        name: 'update-reward-category',
        query: { id },
      }).href;
      window.open(url, '_blank');
    },
    handleViewDetailProgram(id) {
      const url = this.$router.resolve({
        name: 'update-reward-program',
        query: { id },
      }).href;
      window.open(url, '_blank');
    },
    handleReset() {
      this.selectedRewardType = REWARD_CHECK_TYPE.CH;
      this.selectedProductName = null;

      this.selectedProductId = null;
      this.selectedStoreName = null;
      this.selectedStoreId = null;
      this.selectedDepartmentName = null;
      this.selectedDepartmentId = null;
      this.selectedMonth = new Date();
      this.componentKey++;

      this.rewardPrograms = [];
      this.renderListRewardProgram = false;

      this.listProductFilter = [];
      this.filteredStoreOptions = [...this.storeOptions];
      this.filteredDepartmentOptions = [...this.departmentOptions];

      this.$nextTick(() => {
        this.makeToastSuccess('Đã reset dữ liệu!');
      });
    },
  },
};
</script>

<style scoped>
.hover-link {
  color: #007bff;
}

.hover-link:hover {
  cursor: pointer;
  opacity: 0.6;
}
</style>
